import { useQuery } from '@tanstack/react-query';
import { candidateAppService } from '../services/candidate-app.service';

export function useCandidateByShareId(shareId: string): {
  candidate: ReturnType<typeof candidateAppService.getCandidateByShareId> extends Promise<infer T>
    ? T | undefined
    : never;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const query = useQuery({
    queryKey: ['candidate-public', shareId],
    queryFn: () => candidateAppService.getCandidateByShareId(shareId),
    enabled: !!shareId,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    candidate: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
